'use es6';

import * as OperatorTypes from './ListSegClassicOperatorTypes';
import * as Operators from '../../filterQueryFormat/operator/Operators';
export default {
  // PROPERTY
  [OperatorTypes.AFTER]: Operators.After,
  [OperatorTypes.BEFORE]: Operators.Before,
  [OperatorTypes.BETWEEN]: Operators.InRange,
  [OperatorTypes.CONTAIN]: Operators.ContainAny,
  [OperatorTypes.CONTAIN_ALL]: Operators.ContainAll,
  [OperatorTypes.CONTAIN_ALL_TEAMS]: Operators.ContainAllTeams,
  [OperatorTypes.ENDS_WITH]: Operators.EndsWithAny,
  [OperatorTypes.EQUAL]: Operators.Equal,
  [OperatorTypes.EQUAL_ALL]: Operators.EqualAll,
  [OperatorTypes.EQUAL_ANY]: Operators.EqualAny,
  [OperatorTypes.EVER_CONTAINED_ALL]: Operators.EverContainedAll,
  [OperatorTypes.EVER_CONTAINED_ANY]: Operators.EverContainedAny,
  [OperatorTypes.EVER_EQUAL]: Operators.EverEqual,
  [OperatorTypes.EVER_EQUAL_ANY]: Operators.EverEqualAny,
  [OperatorTypes.EVER_IN]: Operators.EverIn,
  [OperatorTypes.GREATER]: Operators.Greater,
  [OperatorTypes.GREATER_OR_EQUAL]: Operators.GreaterOrEqual,
  [OperatorTypes.GREATER_THAN_ROLLING]: Operators.GreaterThanRolling,
  [OperatorTypes.IN]: Operators.In,
  [OperatorTypes.KNOWN]: Operators.Known,
  [OperatorTypes.LESS]: Operators.Less,
  [OperatorTypes.LESS_OR_EQUAL]: Operators.LessOrEqual,
  [OperatorTypes.LESS_THAN_ROLLING]: Operators.LessThanRolling,
  [OperatorTypes.NOT_BETWEEN]: Operators.NotInRange,
  [OperatorTypes.NOT_CONTAIN]: Operators.NotContainAny,
  [OperatorTypes.NOT_CONTAIN_ALL]: Operators.NotContainAll,
  [OperatorTypes.NOT_EQUAL]: Operators.NotEqual,
  [OperatorTypes.NOT_EQUAL_ALL]: Operators.NotEqualAll,
  [OperatorTypes.NOT_EQUAL_ANY]: Operators.NotEqualAny,
  [OperatorTypes.NOT_EVER_CONTAINED_ALL]: Operators.NeverContainedAll,
  [OperatorTypes.NOT_EVER_CONTAINED_ANY]: Operators.NeverIn,
  [OperatorTypes.NOT_EVER_EQUAL]: Operators.NeverEqual,
  [OperatorTypes.NOT_EVER_EQUAL_ANY]: Operators.NeverEqualAny,
  [OperatorTypes.NOT_IN]: Operators.NotIn,
  [OperatorTypes.NOT_KNOWN]: Operators.NotKnown,
  [OperatorTypes.STARTS_WITH]: Operators.StartsWithAny,
  // PRIVACY CONSENT (Appears in the UI as an contact property field)
  [OperatorTypes.HAS_PRIVACY_CONSENT]: Operators.PrivacyConsentCompleted,
  [OperatorTypes.HAS_NOT_PRIVACY_CONSENT]: Operators.PrivacyConsentNotCompleted,
  // CTA
  [OperatorTypes.CTA_HAS_CLICKED]: Operators.CtaHasClicked,
  [OperatorTypes.CTA_NOT_HAS_CLICKED]: Operators.CtaHasNotClicked,
  [OperatorTypes.CTA_HAS_SEEN]: Operators.CtaHasSeen,
  [OperatorTypes.CTA_NOT_HAS_SEEN]: Operators.CtaHasNotSeen,
  // EMAIL
  [OperatorTypes.EMAIL_BOUNCED]: Operators.EmailBounced,
  [OperatorTypes.EMAIL_CLICKED]: Operators.EmailLinkClicked,
  [OperatorTypes.EMAIL_MARKED]: Operators.EmailMarked,
  [OperatorTypes.EMAIL_OPENED]: Operators.EmailOpened,
  [OperatorTypes.EMAIL_OPENED_NOT_CLICKED]: Operators.EmailOpenedButLinkNotClicked,
  [OperatorTypes.EMAIL_OPENED_NOT_REPLIED]: Operators.EmailOpenedButNotReplied,
  [OperatorTypes.EMAIL_RECEIVED]: Operators.EmailReceived,
  [OperatorTypes.EMAIL_RECEIVED_NOT_OPENED]: Operators.EmailReceivedButNotOpened,
  [OperatorTypes.EMAIL_REPLIED]: Operators.EmailReplied,
  [OperatorTypes.EMAIL_SENT]: Operators.EmailSent,
  [OperatorTypes.EMAIL_SENT_NOT_CLICKED]: Operators.EmailSentButLinkNotClicked,
  [OperatorTypes.EMAIL_SENT_NOT_RECEIVED]: Operators.EmailSentButNotReceived,
  [OperatorTypes.EMAIL_UNSUBSCRIBED]: Operators.EmailUnsubscribed,
  // EMAIL SUBSCRIPTION
  [OperatorTypes.HAS_NOT_OPTED]: Operators.EmailSubscriptionNotOpted,
  [OperatorTypes.HAS_OPTED_IN]: Operators.EmailSubscriptionOptIn,
  [OperatorTypes.HAS_OPTED_OUT]: Operators.EmailSubscriptionOptOut,
  // EVENT
  [OperatorTypes.EVENT_HAS]: Operators.EventCompleted,
  [OperatorTypes.EVENT_NOT_HAS]: Operators.EventNotCompleted,
  // FORM
  [OperatorTypes.FORM_FILLED_OUT]: Operators.FormFilledOut,
  [OperatorTypes.FORM_NOT_FILLED_OUT]: Operators.FormNotFilledOut,
  // IMPORT
  [OperatorTypes.IN_IMPORT]: Operators.InImport,
  [OperatorTypes.NOT_IN_IMPORT]: Operators.NotInImport,
  // LIST
  [OperatorTypes.LIST_IN]: Operators.ListIsMember,
  [OperatorTypes.LIST_NOT_IN]: Operators.ListIsNotMember,
  // PAGEVIEW
  [OperatorTypes.PAGEVIEW_CONTAINS]: Operators.PageViewContain,
  [OperatorTypes.PAGEVIEW_EQUAL]: Operators.PageViewEqual,
  [OperatorTypes.PAGEVIEW_MATCHES]: Operators.PageViewMatchRegex,
  [OperatorTypes.PAGEVIEW_NOT_CONTAINS]: Operators.PageViewNotContain,
  [OperatorTypes.PAGEVIEW_NOT_EQUAL]: Operators.PageViewNotEqual,
  [OperatorTypes.PAGEVIEW_NOT_MATCHES]: Operators.PageViewNotMatchRegex,
  // SURVEY_MONKEY
  [OperatorTypes.SURVEY_RESPONDED]: Operators.SurveyMonkeyHasResponded,
  [OperatorTypes.SURVEY_NOT_RESPONDED]: Operators.SurveyMonkeyNotHasResponded,
  [OperatorTypes.SURVEY_ANSWERED]: Operators.SurveyMonkeyHasAnswered,
  // WEBINAR
  [OperatorTypes.WEBINAR_ATTENDED]: Operators.WebinarHasAttended,
  [OperatorTypes.WEBINAR_REGISTERED]: Operators.WebinarHasRegistered,
  [OperatorTypes.WEBINAR_NOT_ATTENDED]: Operators.WebinarNotHasAttended,
  [OperatorTypes.WEBINAR_NOT_REGISTERED]: Operators.WebinarNotHasRegistered,
  // WORKFLOW
  [OperatorTypes.WORKFLOW_ACTIVE]: Operators.WorkflowActive,
  [OperatorTypes.WORKFLOW_NOT_ACTIVE]: Operators.WorkflowNotActive,
  [OperatorTypes.WORKFLOW_COMPLETED]: Operators.WorkflowCompleted,
  [OperatorTypes.WORKFLOW_NOT_COMPLETED]: Operators.WorkflowNotCompleted,
  [OperatorTypes.WORKFLOW_ENROLLED]: Operators.WorkflowEnrolled,
  [OperatorTypes.WORKFLOW_NOT_ENROLLED]: Operators.WorkflowNotEnrolled,
  [OperatorTypes.WORKFLOW_MET_GOAL]: Operators.WorkflowMetGoal,
  [OperatorTypes.WORKFLOW_NOT_MET_GOAL]: Operators.WorkflowNotMetGoal

  /*
  // INTEGRATION
  // TODO crabideau:
  // https://git.hubteam.com/HubSpot/Cerebro/blob/a8333f3199d794eeff0e0e1eaa8fd193b3cb423f/static/coffee/constants/IntegrationOperators.coffee
  */
};